// Measurements come back one point per channel; an uplink is every point
// sharing the same timestamp.
export const groupReadings = (readings = []) => {
  const byTime = new Map();

  (readings || []).forEach((r) => {
    const { channel, type, unit } = r.metadata || {};
    const value = type === 'gps' ? r.array_value : r.value;
    if (!byTime.has(r.timestamp)) byTime.set(r.timestamp, []);
    byTime.get(r.timestamp).push({ channel, type, unit, value });
  });

  return [...byTime.entries()]
    .map(([timestamp, items]) => ({
      timestamp,
      readings: items.sort((a, b) => Number(a.channel) - Number(b.channel)),
    }))
    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
};

export const toPayload = (uplink) => ({
  timestamp: uplink.timestamp,
  payload: uplink.readings.map(({ channel, type, value, unit }) => ({
    channel,
    type,
    value,
    unit,
  })),
});
